import React, { PureComponent } from "react";
import { mFormatter } from "../utils";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsCustomEvents from "highcharts-custom-events";

HighchartsCustomEvents(Highcharts);
class PlatformWiseEntityAnalysisCharts extends PureComponent {
    chartComponent = React.createRef();

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount && this.props.data && !this.props.data.nodata) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    getOptions = () => {
        let data = this.props.data;
        let total = data.total;
        let self = this;
        let chartData = data.chartData;

        let chartConfig = {
            chart: {
                type: "pie",
                className: "skiptranslate",
                backgroundColor: "transparent",
                // margin: [0, 0, 0, 0],
                // spacingTop: 0,
                // spacingBottom: 0,
                // spacingLeft: 0,
                // spacingRight: 0,
                events: {},
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            title: {
                text: "",
                // useHTML: true,
                // verticalAlign: "middle",
                // text: `<img src="${
                //     process.env.PUBLIC_URL + "/icons/charts/platformIcons/" + data.platformShortName.toLowerCase() + ".png"
                // }"/><span>${mFormatter(total)}</span><span>Mentions</span>`,
                // style: {
                //     fontFamily: "'Roboto', sans-serif",
                //     textTransform: "normal",
                //     fontSize: "12px",
                //     display: "flex",
                //     "flex-direction": "column",
                //     "justify-content": "center",
                //     "align-items": "center",
                // },
            },
            credits: {
                enabled: false,
            },
            plotOptions: {
                pie: {
                    borderWidth: 0,
                    shadow: false,
                    showInLegend: true,
                    dataLabels: {
                        enabled: this.props.showLabel,
                        distance: "10%",
                        format: "{point.name}: {point.percentage:.1f} %",
                        style: {
                            fontWeight: 400,
                            textOutline: "none",
                        },
                    },
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                },
            },
            legend: {
                enabled: this.props.showLegend,
                itemStyle: {
                    fontWeight: 500,
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                },
                alignColumns: false,
                margin: 0,
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },
            series: [
                {
                    // innerSize: "60%",
                    data: chartData,
                },
            ],
            tooltip: {
                followPointer: true,
                followTouchMove: true,
                outside: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                },
                formatter: function () {
                    return `${data.platformName}<br/>${this.point.name} | <b>${this.point.percentage.toFixed(1) + "%"}</b> | <b>${
                        this.point.doc_count
                    }/${total}</b>`;
                },
            },
        };
        return chartConfig;
    };

    render() {
        return (
            <HighchartsReact
                highcharts={Highcharts}
                options={this.getOptions()}
                ref={this.chartComponent}
                containerProps={{ style: { width: "100%", height: "calc(100% - 20px)" } }}
            />
        );
    }
}

export default PlatformWiseEntityAnalysisCharts;
